import React from "react";
import Header from "./ui/header";
import Table from "./ui/table";

export default function OrderList() {
  return (
    <>
      {/* <Header /> */}
      <Table />
    </>
  );
}
